import React, { useState, useEffect } from "react";
import { Row, Col, Button, Modal, Input, Table } from "antd";
import { RESTExecutor, withDomains } from "../../lib/domain";
import { Link } from "react-router-dom";
import ErrorWrapper from "../../lib/error_wrapper";

const DirectSourceReport = (props) => {
  const plugin_columns = [
    {
      title: "Plugin Name",
      dataIndex: "report_name",
      key: "report_name",
    },
    {
      title: "",
      dataIndex: "report_id",
      key: "report_id",
      render: (id) => (
        <Link
          to={{
            pathname: `/reports/adhoc/${id}`,
          }}
        >
          Create
        </Link>
      ),
    },
  ];

  const [visible, setVisible] = useState(false);

  const list_plugins = RESTExecutor.list()
    .config({
      label: "direct_report_plugins",
    })
    .forId(props.source_name)
    .callbacks(
      (success) => {
        console.log(success);
      },
      (error) => {
        console.log(error);
      }
    )
    .connect(props.domains.reports);

  useEffect(() => {
    // list_plugins.execute();
  }, []);

  let list_plugins_resp = list_plugins.response();
  let rowsData =
    (list_plugins_resp.result && list_plugins_resp.result.rows) || [];
  let filteredData = JSON.parse(JSON.stringify(rowsData));

  const showModal = () => {
    list_plugins.execute();
    setVisible(true);
  };

  const handleOk = () => {
    setVisible(false);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  return (
    <>
      <Button type="link" onClick={showModal}>
        Reports
      </Button>
      <Modal
        title="Adhocs"
        visible={visible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        style={{ top: 10 }}
      >
        <ErrorWrapper error={list_plugins_resp} onReload={()=>{
          list_plugins.execute();
        }}>
        <Table
          scroll={{ x: true }}
          bordered={false}
          pagination={{ pageSize: 12 }}
          //   className="main-table"
          columns={plugin_columns}
          dataSource={filteredData}
          loading={list_plugins_resp.fetching}
          size="small"
        />
        </ErrorWrapper>
      </Modal>
    </>
  );
};

export default withDomains(DirectSourceReport, "reports");
